module.exports = __webpack_public_path__ + "static/headerIndex-561e3b5d4a9079d5045b99cb81cbc8a7.jpg";